export default "<app-iframe-bo [page]=\"iframe\"></app-iframe-bo>"